// extracted by mini-css-extract-plugin
module.exports = {"container_body":"BasicHtmlContent_container_body__3GTB6","container":"BasicHtmlContent_container__2k9MJ"};